import NextImage from 'next/image'
import { Nameplate } from '@mc/design-system'
import { useStaticData } from '@mc/static-data-react'
import { PrunedCourse } from 'libs/server/api'
import classes from './Hero.module.scss'

export const DefaultNameplate = () => {
  const { course } = useStaticData<{
    course: PrunedCourse
  }>()

  if (!course.leftAlignedNameplate) return null

  const nameplate =
    course.slug === 'the-power-playbook' // Workaround for https://ourmasterclass.slack.com/archives/C02S9J0L0DN/p1758902506859879
      ? course.nameplate
      : course.leftAlignedNameplate

  return (
    <>
      {/* Desktop */}
      <div className='d-none d-lg-block'>
        <Nameplate
          size='medium'
          image={
            <h1 className='mc-w-100 d-flex align-items-start justify-content-start mc-my-4'>
              <NextImage
                alt={course.instructorName || ''}
                className={classes.nameplateImage}
                src={nameplate || ''}
                objectFit='contain'
                sizes='220px'
                layout='fill'
                priority
              />
            </h1>
          }
          subText={course.headline}
          className={classes.nameplate}
        />
      </div>

      {/* Tablet and Mobile */}
      <div className='d-block d-lg-none mc-my-3'>
        <Nameplate
          size='small'
          image={
            <h1 className='mc-w-100 d-flex align-items-start justify-content-start mc-mb-3'>
              <NextImage
                alt={course.instructorName || ''}
                className={classes.nameplateImage}
                src={nameplate || ''}
                objectFit='contain'
                sizes='150px'
                layout='fill'
                priority
              />
            </h1>
          }
          subText={course.headline}
          className={classes.nameplate}
          align='bottom'
        />
      </div>
    </>
  )
}
